import { setLocale } from 'yup';

import { ErrorMessage } from '@/utils/Messages';

/**
 * Traduz as mensagens padrão do Yup.
 *
 * `notType` precisa estar aqui: sem ele o Yup vaza a mensagem crua em inglês
 * (ex.: "must be a `boolean` type, but the final value was: `null`") direto
 * para o toast do usuário.
 */
export const configureYupLocale = (): void => {
  setLocale({
    mixed: {
      required: ErrorMessage.required(),
      default: ErrorMessage.invalid(),
      notType: ErrorMessage.invalid(),
    },
  });
};

export default configureYupLocale;
